export default "__VITE_ASSET__DIO4ea$4__"